import React, { useEffect, useState } from "react";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/lib/toast";
import { shopifyApi } from "@/data/api";
import { Field, TextField, SaveBar } from "@/components/adminui";

export default function AdminShopify() {
  const { colors } = useTheme();
  const { token } = useAuth();
  const toast = useToast();
  const [domain, setDomain] = useState("");
  const [affiliateUrl, setAffiliateUrl] = useState("");
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    shopifyApi.adminGetConfig(token).then((r) => { setDomain(r.store_domain || ""); setAffiliateUrl(r.affiliate_url || ""); setConnected(!!r.connected); }).catch(() => {}).finally(() => setLoading(false));
  }, [token]);

  const save = async () => {
    setSaving(true);
    try {
      const r = await shopifyApi.adminSetConfig({ store_domain: domain.trim(), affiliate_url: affiliateUrl.trim() }, token);
      setConnected(!!r.connected);
      toast.show(r.connected ? "Store connected ✨" : "Saved");
    } catch (e) { toast.show(e.message || "Couldn't save"); } finally { setSaving(false); }
  };

  if (loading) return <Screen><TopBar title="Shopify" /><Loader /></Screen>;

  return (
    <Screen>
      <TopBar title="Shopify store" subtitle="Connect your live catalogue" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, background: connected ? "#3B7A5722" : colors.surfaceSecondary, border: `1px solid ${connected ? "#3B7A57" : colors.border}`, borderRadius: 14, padding: 14, marginBottom: 18 }}>
          <Icon name={connected ? "check-circle" : "shopping-bag"} size={20} color={connected ? "#3B7A57" : colors.muted} />
          <span style={{ color: colors.onSurface, fontSize: 14, fontWeight: 600, fontFamily: fonts.text }}>{connected ? "Connected — products are live in the app" : "Not connected yet"}</span>
        </div>
        <Field label="Store domain" hint="e.g. your-store.myshopify.com — tokenless, only public products are shown"><TextField value={domain} onChange={setDomain} data-testid="shopify-domain" placeholder="your-store.myshopify.com" /></Field>
        <Field label="Affiliate dashboard URL" hint="UpPromote / affiliate link reps use to earn commission"><TextField value={affiliateUrl} onChange={setAffiliateUrl} placeholder="https://..." /></Field>
        <SaveBar onSave={save} saving={saving} saveLabel={domain.trim() ? "Save & connect" : "Disconnect"} />
      </div>
    </Screen>
  );
}
